import { OrderChannel, OrderChannelHelper, ReportType, ReportTypeHelper } from '@biteinc/enums';

import { ReportHelper } from '../helpers/report_helper';
import { TimeHelper } from '../helpers/time_helper';
import { oneTimeReportSchema } from './one_time_report_schema';

app.OneTimeReport = app.AbstractModel.extend({
  ModelName: 'oneTimeReport',
  Schema: oneTimeReportSchema,

  // We get the timestamp as the beginning of the day in whatever timezone the browser is in.
  // So we must convert it to be 4am in the specified timezone.
  defaults() {
    const reportDefaults = {
      // Add our user's email by default so they don't have to type it in
      ...(app.sessionUser?.attributes.username && {
        emailAddresses: [`${app.sessionUser?.attributes.username}`],
      }),
    };

    return {
      ...reportDefaults,
      orderChannels: ReportHelper.getAvailableOrderChannels(),
    };
  },

  save(data, opts) {
    if (data.dateRange) {
      data.dateRange.from = TimeHelper.localMoment(data.dateRange.from).format('YYYY-MM-DD');
      data.dateRange.to = TimeHelper.localMoment(data.dateRange.to).format('YYYY-MM-DD');
    }

    app.QueueHelper.makeRequest('POST', '/api/v2/reporting/one-off', data, true, (err, result) => {
      if (err) {
        if (opts.error) {
          opts.error(err);
        }
        return;
      }

      if (opts.success) {
        opts.success(this, result || {});
      }
    });
  },

  getFieldCollection(field, _subProperty, _includeAllValues, _keyModel) {
    switch (field) {
      case 'type': {
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: ReportType,
          nameGenerator: ReportTypeHelper.name,
          values: ReportHelper.getAvailableReportTypes(
            true,
            app.sessionUser,
            app.org,
            app.site,
            app.location,
            app.getSettingsFromContext(),
          ),
        });
      }
      case 'orderChannels': {
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: OrderChannel,
          values: ReportHelper.getAvailableOrderChannels(),
          nameGenerator: OrderChannelHelper.nameCombiningKioskAndFlash,
        });
      }
      case 'locationGroupId':
        return app.LocationGroupList.newSelectableList(app.locationGroupList, {
          includeOrgWide: true,
          includeAllLive: true,
          includeSingleLocationGroups: true,
        });
      case 'salesByLocationGroupIds':
        return app.LocationGroupList.newSelectableList(app.locationGroupList);
      case 'vendorId':
        return app.vendorList;
    }
    return null;
  },

  displayNameForListFieldElement(field, element, subProperty, keyModel, plainTextOnly) {
    const displayName = plainTextOnly ? element.displayName() : element.displayNameHtml();
    switch (field) {
      case 'locationGroupId':
      case 'salesByLocationGroupIds': {
        const locationGroup = element;
        return locationGroup.displayNameAsListFieldElement(plainTextOnly);
      }
    }
    return displayName;
  },
});
